import React from 'react'
import MenuItem from '../MenuItem'
import {Box} from '@mui/material'
import {toast} from 'sonner'
import {useTranslation} from 'react-i18next'
import {showConfirmAlert} from 'services/alert'
import {useEditMeterMutation} from 'store/Store'
import BookmarkRoundedIcon from '@mui/icons-material/BookmarkRounded'

const SetLastMeterReadingMenuItem = ({itemId, handleClose, rowData}) => {
    const [editMeter] = useEditMeterMutation()
    const {t} = useTranslation()

    const meterId = rowData?.meter?._id || rowData?.meter
    if (!meterId) return null

    const onClickHandler = (e) => {
        handleClose?.(e)
        showConfirmAlert({
            e,
            text: t('meter_readings.setLastReading.confirm'),
            onConfirm: () =>
                toast.promise(
                    editMeter({_id: meterId, meterReading: itemId}).unwrap(),
                    {
                        loading: t('loading'),
                        success: () => t('meter_readings.setLastReading.success'),
                        error: (err) =>
                            err?.data?.error || t('meter_readings.setLastReading.error'),
                    }
                ),
            disableSuccessAlert: true,
            t,
        })
    }

    return (
        <MenuItem key={`table_action_set_last_reading_${itemId}`} onClick={onClickHandler}>
            <Box display="flex" justifyContent="space-between" width="100%" gap={1}>
                <div>{t('menuItem.set_last_meter_reading')}</div>
                <BookmarkRoundedIcon />
            </Box>
        </MenuItem>
    )
}

export default SetLastMeterReadingMenuItem
